import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./AnimatedTabs.css";

const AnimatedTabs = ({ tabs, className, initialTabId }) => {
  const [activeTab, setActiveTab] = useState(initialTabId || tabs[0]?.id);

  useEffect(() => {
    if (initialTabId) {
      setActiveTab(initialTabId);
    }
  }, [initialTabId]);

  if (!tabs?.length) return null;

  return (
    <div className={`animated-tabs-wrapper ${className || ""}`}>
      {/* Tab Header */}
      <div className="tabs-header-container">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`tab-trigger ${activeTab === tab.id ? "active" : ""}`}
            type="button"
          >
            {activeTab === tab.id && (
              <motion.div
                layoutId="active-tab-bg"
                className="active-tab-indicator"
                transition={{ type: "spring", bounce: 0.2, duration: 0.6 }}
              />
            )}
            <span className="tab-label">{tab.label}</span>
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="tabs-content-area">
        <AnimatePresence mode="wait">
          {tabs.map(
            (tab) =>
              activeTab === tab.id && (
                <motion.div
                  key={tab.id}
                  initial={{
                    opacity: 0,
                    scale: 0.98,
                    y: 10,
                    filter: "blur(10px)",
                  }}
                  animate={{ opacity: 1, scale: 1, y: 0, filter: "blur(0px)" }}
                  exit={{ opacity: 0, scale: 0.98, y: -10, filter: "blur(10px)" }}
                  transition={{
                    duration: 0.4,
                    ease: [0.4, 0, 0.2, 1],
                  }}
                  className="tab-panel-motion"
                >
                  <div className="tab-panel-grid">
                    <div className="tab-panel-image">
                        <img src={tab.image} alt={tab.heading} />
                    </div>
                    <div className="tab-panel-text">
                        <h2 className="tab-panel-title">{tab.heading}</h2>
                        <p className="tab-panel-desc">{tab.content}</p>
                    </div>
                  </div>
                </motion.div>
              )
          )}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default AnimatedTabs;
